<div [ngClass]="{accessible: accessibilityMode}"
  class="strip-container"
  *ngIf="showFaceGateWarning">
  <vi-ui-alert-message [type]="AlertMessageType.WARNING_INFO"
    [content]="faceGateStripMessage"
    [linkText]="faceGateStripLinkText"
    [linkPath]="faceGateStripLinkPath"
    [isButton]="!faceGateStripLinkPath"
    (buttonClicked)="handleLinkNavigation()"></vi-ui-alert-message>
</div>